import { Link } from "@material-ui/core";
import { ColumnDefinition } from "components/LynxTable/ColumnDefinition";
import { separateThousands } from "helpers/separateThousands";
import { LaneDetails } from "models/laneDetails/LaneDetails";
import { theme } from "styling/theme";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import { RiskChip } from "components/RiskChip/RiskChip";

export const globalViewTableColumns: ColumnDefinition<LaneDetails>[] = [
    {
        id: "laneName",
        headerTitle: "identifier",
        render: ({ laneName, laneId }: LaneDetails) => {
            const { url } = useRouteMatch();

            return (
                <Link
                    component={RouterLink}
                    to={`${url}/lanes/${laneId}`}
                    style={{ color: theme.colors.primary.blue500 }}
                >
                    {laneName}
                </Link>
            );
        },
    },
    {
        id: "transportationModes",
        headerTitle: "mode(s)  of transportation",
        align: "left",
    },
    {
        id: "riskLevel",
        headerTitle: "risk level",
        render: ({ riskLevel }: LaneDetails) => (
            <RiskChip
                riskLevel={
                    riskLevel.toLowerCase() as
                        | "low"
                        | "high"
                        | "medium"
                        | "healthy"
                }
            />
        ),
        sortable: true,
        align: "left",
    },
    {
        id: "reason",
        headerTitle: "reason",
        sortable: true,
        align: "left",
    },
    {
        id: "alertsCount",
        headerTitle: "number  of alerts",
        render: (rowData: LaneDetails) => "None",
        align: "left",
    },
    {
        id: "shipmentCount",
        headerTitle: "number of shipments",
        render: ({ shipmentCount }: LaneDetails) =>
            separateThousands(shipmentCount),
        align: "right",
        sortable: true,
    },
];
